"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const Wrapper = styled_components_1.styled.div `
  position: relative;
  margin: 0;
  height: 20px;
  width: 20px;
  border-radius: ${(props) => props.theme.radius};
  background: ${(props) => props.theme.bg};
`;
const Tick = styled_components_1.styled.span `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Segoe UI Symbol", "Apple Symbols", normal, sans-serif;
`;
const Input = styled_components_1.styled.input `
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:focus ~ ${Tick} {
    outline: solid 1px ${(props) => props.theme.fg};
  }
  &:disabled {
    opacity: 0.3;
    cursor: default;
    border-color: transparent;
  }
`;
const Checkbox = ({ checked, id, symbol, onChange, title, name, disabled, autoFocus, }) => {
    return (react_1.default.createElement(Wrapper, { title: title },
        react_1.default.createElement(Input, { type: "checkbox", checked: checked, id: id, onChange: onChange, "aria-label": `checkbox ${name}`, name: `checkbox ${name}`, readOnly: true, disabled: disabled, "data-testid": `checkbox-${name}`, autoFocus: autoFocus }),
        react_1.default.createElement(Tick, { role: "img", style: { opacity: disabled ? 0.75 : 1 } }, symbol !== null && symbol !== void 0 ? symbol : (checked && "✔"))));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map